// extracted by mini-css-extract-plugin
module.exports = {"blogContent":"app_blogContent__1xaAQ","galleryContainer":"app_galleryContainer__0_s5S"};